import React from "react"
import { Switch } from "@/components/ui/switch"
import { Label } from "@/components/ui/label"

interface CitationsToggleProps {
  enabled: boolean
  onChange: (enabled: boolean) => void
}

export function CitationsToggle({ enabled, onChange }: CitationsToggleProps) {
  return (
    <div className="flex items-center gap-2">
      <Switch
        id="citations-toggle"
        checked={enabled}
        onCheckedChange={onChange}
      />
      <Label htmlFor="citations-toggle" className="text-sm">
        Show compliance citations
      </Label>
    </div>
  )
}
